// Smooth scroll for in-page anchor links only — avoids global scroll-behavior jank
(function() {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  function scrollToTarget(target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href || href === '#') return;

      var target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      scrollToTarget(target);
      history.pushState(null, '', href);
    });

    if (window.location.hash) {
      var initialTarget = document.querySelector(window.location.hash);
      if (initialTarget) {
        requestAnimationFrame(function() {
          scrollToTarget(initialTarget);
        });
      }
    }
  });
})();
